import React, { useState } from 'react';
import './PaymentGateway.css'
import { Link } from 'react-router';
import {
  FaCartArrowDown,
  FaMobileAlt,
  FaGraduationCap,
  FaStore,
} from "react-icons/fa";
import { FaBuildingUser } from "react-icons/fa6";
const PaymentGateway = () => {
  const cards = [
    {
      title: "Payment Gateway Support for E-Commerce",
      text: "Running an online store? We support businesses that already use payment gateways by helping improve transaction success rates, reduce payment failures, manage settlements, and handle chargebacks. Our goal is to keep your payment system smooth and reliable.",
      icon: <FaCartArrowDown />,
      label: "E-Commerce",
    },
    {
      title: "Payment Gateway Support for Apps",
      text: "For mobile apps, smooth checkout is critical. We assist with API integration guidance, webhook troubleshooting, payment decline analysis, and performance optimization to ensure your users enjoy seamless transactions.",
      icon: <FaMobileAlt />,
      label: "Apps",
    },
    {
      title: "Payment Gateway Support for Education",
      text: "Schools, colleges, and academies often manage large fee collections. We provide support in reconciliation, transaction tracking, settlement clarification, and compliance assistance to ensure secure and organized payment operations.",
      icon: <FaGraduationCap />,
      label: "Education Sector",
    },
    {
      title: "Payment Gateway Support for Retail",
      text: "Retail businesses using card, UPI, or online payment systems may face settlement delays or technical issues. We help monitor performance, resolve payment disputes, and optimize transaction success rates across all payment modes.",
      icon: <FaStore />,
      label: "Retail",
    },
    {
      title: "Payment Gateway Support for PSU",
      text: "Government bodies and PSUs require reliable and compliant payment systems. We assist in documentation coordination, provider communication, transaction monitoring, and large-scale reconciliation support for smooth payment management.",
      icon: <FaBuildingUser />,
      label: "PSU",
    },
  ];


  return (
    <div className='paymentgateway'>
      <div className="container">
        <div className="row  align-items-center">
          <div className="col-lg-12">
            <div className="section-title text-center">
              <h3 className="wow fadeInUp">Payment Gateway</h3>
              <h2 className="text-anime-style-2" data-cursor="-opaque">
                Get Your Business Payment System Running Smoothly
              </h2>
              <p>We specialize in helping businesses manage and optimize their existing payment gateways.</p>
            </div>
          </div>


        </div>

        <div className="card-grid">
          {cards.map((card, index) => (
            <div className="backandfront position-relative" key={index}>
              <div className="overlay">
                <h2>{card.title}</h2>
                <p>{card.text}</p>
              </div>

              <div className="content_design">
                <div className="icon_container">{card.icon}</div>
                <p>{card.label}</p>
                <div className="bgimagealldesign"></div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PaymentGateway;